import { Button, CircularProgress, Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import headerLogo from '../../../assets/images/logo.svg'
import { useForm } from "react-hook-form";
import { Link } from 'react-router-dom';
import loginFooterImg from '../../../assets/images/loginFooterImg.svg'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reduxState/store';
import OtpInput from 'react-otp-input';
import {otpLogin, clearState} from '../../../reduxState/authSlice/otp';
import modalCancel from '../../../assets/images/modalCancel.png'
import AppSnackbar from '../../commonToast/customizeAlert';
import { RequestForToken } from '../../notification/firebase';

interface Props {
  isOpen: any;
  onOtpClose: any;
}

const Otp: React.FC<Props> = ({ isOpen , onOtpClose }) => {
  const dispatch = useDispatch<AppDispatch>();
  const loginToken = useSelector((state: RootState) => state.Otp);
  const [otp, setOtp] = React.useState('');
  const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = React.useState(false);
  const { handleSubmit, reset } = useForm();
  const [disable, setDisable] = React.useState<any>(false);
  const FCM = localStorage.getItem("FCM") ? localStorage.getItem("FCM") : ''

  // Alert message
  React.useEffect(() => {
    if (loginToken.code === 200 && loginToken.loading === false) {
      onOtpClose();
      localStorage.setItem("AUTH_TOKEN", loginToken.data);
      dispatch(clearState())
      reset({
        payload : {
            otp:'',
        }
      })
      window.location.reload()
    } else if (loginToken.code === 400) {
      setIsErrorSnackbarOpen(true);
    }
  }, [loginToken.code]);

  React.useEffect(() => {
    RequestForToken()
  },[])

  const onSubmit = () => {
    setDisable(true)
    dispatch(clearState())
    if (otp === '1234') {
      const number = localStorage.getItem("Number");
        const payload = {
            mobileNo: number,
            otp:otp,
            deviceToken: FCM,
            deviceType: "Web",
        }
        dispatch(otpLogin(payload))
    }else{
      setIsErrorSnackbarOpen(true)
    }    
  }

  const handleCloseButton = () => {
    onOtpClose()
    reset({
      payload : {
          otp:'',
      }
    })
  }

  const handleSnackbarClose = () => {
    setIsErrorSnackbarOpen(false);
    dispatch(clearState())
    setDisable(false)
  };

  return (
    <React.Fragment>
      <Modal open={isOpen} onClose={onOtpClose}>
        <Box className='login-width' sx={{ position: 'absolute', top: '33%', left: '50%', transform: 'translate(-50%, -50%)', height: 'auto', bgcolor: 'background.paper', boxShadow: 24, borderRadius: '21px' }}>
        <Box sx={{textAlign:'center', position:'relative'}} p={3} pb={0}>
            <img src={headerLogo} alt="Header-logo" width='60%' loading='lazy'/>
            <Button variant='text' onClick={handleCloseButton} sx={{position:'absolute', right:'10px', top:'24px'}}><img src={modalCancel} alt="Delete button" className='delete-icon' loading='lazy' /></Button>
          </Box>
        <Typography className='login-header reem-kulfi' p={5} py={2} mt={2}>One time Password</Typography>
        <Typography className='login-para roboto-med' px={5}>We’ve sent a verification code</Typography>
        <form onSubmit={handleSubmit(onSubmit)} style={{textAlign:'center', paddingLeft:'40px', paddingRight:'40px'}}>
            <Box sx={{width:'100%'}} my={2} className="otp-field">
                <OtpInput
                    value={otp}
                    shouldAutoFocus
                    onChange={setOtp}
                    numInputs={4}
                    renderInput={(props) => <input {...props}/>}
                />
            </Box>
            <Button type='submit' variant='contained' className='login-button reem-kulfi' sx={{ width: '100%', marginTop: '16px', marginBottom: '16px', padding: '8px' }} disabled={disable} onClick={handleSubmit(onSubmit)}>
              {loginToken.loading ? <CircularProgress size={20} sx={{ color: '#FFFFFF', p: 0.25 }} /> : 'Verify'}
            </Button>
        </form>
        <Box textAlign={'center'} py={2}>
            <Link to="/homepage" className='account-create roboto-med'>Not received your OTP? Resend OTP</Link>
        </Box>
        <Box mb={-0.5}>
            <img src={loginFooterImg} alt="Login footer" width='100%' loading='lazy'/>
        </Box>
        </Box>
      </Modal>
      {isErrorSnackbarOpen && (
        <AppSnackbar
          showAlert={isErrorSnackbarOpen}
          message={loginToken.message ?  loginToken.message : 'Please enter a valid otp'}
          type="error"
          onClose={handleSnackbarClose}
        />
      )}
    </React.Fragment>
  );
};
export default Otp;